module.exports = __webpack_public_path__ + "img/ee.e24b6ca0.svg";